'use client'

import type { AnchorHTMLAttributes } from 'react'
import { useButtonTracking } from '@/lib/useButtonTracking'

const SKILLS_REPO_HOST_PATH = 'github.com/AI-Builder-Club/skills'

/** Markdown anchor renderer: fires the skills-repo conversion event whenever an
 * in-body link points at the skills repo, so every post (current and future) is
 * measured without per-post wiring. All other links render unchanged. */
export default function TrackedBodyLink({
  href,
  children,
  ...rest
}: AnchorHTMLAttributes<HTMLAnchorElement>) {
  const { trackButtonClick } = useButtonTracking()
  const isSkillsRepo = typeof href === 'string' && href.includes(SKILLS_REPO_HOST_PATH)

  return (
    <a
      href={href}
      {...rest}
      onClick={
        isSkillsRepo
          ? () =>
              trackButtonClick('skills_repo_cta_click', {
                section: 'blog_body',
                destination: 'github_skills_repo',
                conversion: true,
              })
          : rest.onClick
      }
    >
      {children}
    </a>
  )
}
